import { Space, Table, Tag, Button, Tooltip } from 'antd'
import { Link, Router, Route } from 'react-router-dom'
import CommentCheckModal from '../commentCheckModal/commentCheckModal'
import MessagePopOver from '../../../../components/popOver/popOver'
import './commentTable.css'
import { useImperativeHandle, useState } from 'react'
import { forwardRef } from 'react'
import { commentCheck } from '../../../../api/api'
import moment from 'moment'

const CommentTable = forwardRef((props, ref) => {
  const {setIsFresh} = props
  const columns = [
    {
      title: '评论编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '评论内容',
      dataIndex: 'content',
      key: 'content',
      width: '20%',
      ellipsis: {
        showTitle: false,
      },
      render: (reply_content) => (
        <Tooltip placement="topLeft" title={reply_content}>
          {reply_content}
        </Tooltip>
      ),

      // render: (_, record) => (
      //   <Space size="middle">
      //     <MessagePopOver
      //       comment_content={record.reply_content}
      //     ></MessagePopOver>
      //   </Space>
      // ),
    },
    {
      title: '评论图片',
      dataIndex: 'reply_images',
      key: 'reply_images',
      render: (_, record) => (
        <Space size="middle">
          {record.reply_images ? <span>有</span> : <span>无</span>}
        </Space>
      ),
    },
    {
      title: '评论状态',
      key: 'auditStatus',
      dataIndex: 'auditStatus',
    },
    {
      title: '评论人昵称',
      key: 'author',
      dataIndex: 'author',
    },
    {
      title: '评论人号码',
      key: 'phone',
      dataIndex: 'phone',
      width:'15%'
    },
    {
      title: '评论时间',
      key: 'createdAt',
      dataIndex: 'createdAt',
      width: '15%',
      ellipsis: {
        showTitle: false,
      },
      render: (created_at) => (
        <Tooltip placement="topLeft" title={created_at}>
          {created_at}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
        <Space size="middle">
          <CommentCheckModal setIsFresh={setIsFresh} info={record} />
        </Space>
      ),
    },
  ]
  const [data, setData] = useState([])
  const [changeComment, setChangeComment] = useState([])

    const switchAuditStatus = (num) => {
      switch (num) {
        case 1:
          return '待审核'

        case 2:
          return '审核通过'

        case 3:
          return '审核不通过'

        default:
          break
      }
    }

  const switchtype = (num) => {
    switch (num) {
      case 1:
        return '合租'

      case 2:
        return '转租'

      case 3:
        return '出售'

      case 4:
        return '求购'

      default:
        break
    }
  }

  const changeData = (newData) => {
    newData.map((info, index) => {
      info.createdAt = moment(info.created_at).format('YYYY-MM-DD HH:mm:ss')
      info.auditStatus = switchAuditStatus(info.audit_status)
      info.threadAuditStatus = switchAuditStatus(info.thread_audit_status)
      info.threadType = switchtype(info.thread_type)
      info.key = index   
      // console.log("coment data",info)
      return info

    })
    // console.log(data);
    setData(newData)
  }

  useImperativeHandle(ref, () => ({
    changeData,
  }))

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [loading, setLoading] = useState(false)
  const start = () => {
    setLoading(true)
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([])
      setLoading(false)
    }, 1000)
  }

  //批量取消或者通过评论
  const changeCommentState = (changeKey) => {
    // console.log(changeUsers);
    let arr = []
    changeComment.map((info, index) => {
      return arr.push(info.id)
    })
    // console.log(arr);
        const params = {
          post_ids: arr,
          audit_status: changeKey,
        }
    commentCheck(params).then((res) => {
      console.log(res)
      setIsFresh(pre => !pre)
    })
    setLoading(true)
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([])
      setLoading(false)
    }, 500)
  }
  const cancelComment = () => {
    changeCommentState(3)
  }
  const pastComment = () => {
    changeCommentState(2)
  }

  //当选择的内容变化的时候的回调
  const onSelectChange = (newSelectedRowKeys, record) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    // console.log('the data is:',record);
    setChangeComment(record)
    //遍历一遍record
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const hasSelected = selectedRowKeys.length > 0
  return (
    <div style={{ marginBottom: '20px' }}>
      <div>
        <div
          style={{
            marginBottom: 16,
          }}
        >
          <div className="commentManageButton">
            <Button
              onClick={cancelComment}
              disabled={!hasSelected}
              loading={loading}
              style={{ marginRight: '20px' }}
            >
              批量不通过
            </Button>
            <Button
              type="primary"
              onClick={pastComment}
              disabled={!hasSelected}
              loading={loading}
            >
              批量通过
            </Button>
            <span
              style={{
                marginLeft: 8,
              }}
            >
              {hasSelected ? `已选择 ${selectedRowKeys.length} 项` : ''}
            </span>
          </div>
        </div>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={data}
          scroll={{
            // x: 1000,
            y: 400,
          }}
          pagination={false}
        />
      </div>
    </div>
  )
})

export default CommentTable
